import { EmployeeImportFormat } from '@/common/graphql';

// Matches `export-history/const.tsx`'s `EMPLOYEE_EXPORT_FORMAT_LABELS` semantics: the employee
// import sheet formats a user can pick. Only the employee kind carries a format.
export const EMPLOYEE_IMPORT_FORMAT_LABELS: Record<EmployeeImportFormat, string> = {
  [EmployeeImportFormat.Create]: 'Create Employee',
  [EmployeeImportFormat.GeneralInformation]: 'General Information',
  [EmployeeImportFormat.JobHistoryContract]: 'Job / Contract History',
  [EmployeeImportFormat.ThOnboardingSheet]: 'TH Onboarding Sheet',
  [EmployeeImportFormat.IdOnboardingSheet]: 'ID Onboarding Sheet',
};
